import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  wrappedText: { minWidth: 0, overflowWrap: 'anywhere' },
  text: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  separator: {
    margin: theme.spacing(0, 2)
  },
  empty: {
    fontStyle: 'italic',
    color: theme.colorPalette.beige_75,
    ...reskinStyles(theme, { color: theme.colors.text_secondary })
  },
  editButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0,
    maxWidth: '100%',
    padding: 0,
    border: 0,
    background: 'none',
    font: 'inherit',
    color: 'inherit',
    textAlign: 'left',
    cursor: 'pointer'
  },
  icon: {
    flexShrink: 0,
    width: 16,
    height: 16
  }
}));

export default useStyles;
